import * as React from "react";
import { Tooltip } from "@utdanningsdirektoratet/tooltip";
import { Icon } from "@utdanningsdirektoratet/icon";
import { IconButton } from "@utdanningsdirektoratet/button";
import { useId } from "@utdanningsdirektoratet/utils/useId";
import { cls } from "@utdanningsdirektoratet/utils/cls";
import { RichText } from "..";
import styles from "./TrashableRichText.module.less";

interface TrashableRichTextProps extends React.ComponentProps<typeof RichText> {
  toggled?: boolean;
  onTrash: (event: React.MouseEvent<HTMLButtonElement>) => void;
  trashAriaLabel?: string;
  trashTooltip?: string;
  richtextClassName?: string;
}

const TrashableRichText: React.FC<TrashableRichTextProps> = (props) => {
  const id = useId(props.id);

  const { disabled, className, trashTooltip, richtextClassName, toggled, trashAriaLabel, onTrash, ...rest } = props;

  return (
    <div className={cls(styles.trashableRichText, className)} id={id}>
      <RichText {...rest} disabled={disabled} className={richtextClassName} />
      {!disabled ? (
        <Tooltip className={styles.trashableRichTextIcon} align="right" message={trashTooltip}>
          <IconButton
            aria-expanded={toggled}
            aria-hidden={!toggled}
            aria-controls={id}
            aria-label={trashAriaLabel || trashTooltip}
            onClick={onTrash}
          >
            <Icon icon="trash" />
          </IconButton>
        </Tooltip>
      ) : null}
    </div>
  );
};

export default TrashableRichText;
